/* src/app/features/recuperacao/recuperacao-credito/recuperacao-credito-listagem.component.scss */
.moeda {
  text-align: right;
}
.pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=recuperacao-credito-listagem.component.css.map */
